import React from 'react';
import {SecondaryButton} from 'components';
import i18n from 'i18next';

type AddBitButtonProps = {
  onCreate: () => void;
};

function AddBitButton({onCreate}: AddBitButtonProps) {
  return (
    <div className="w-1/2 h-44 odd:pr-3 even:pl-3 mb-6">
      <SecondaryButton
        className="rounded-huge h-full w-full"
        onClick={onCreate}
      >
        {i18n.t('wisbitPage.addBit')}
      </SecondaryButton>
    </div>
  );
}

export default AddBitButton;
